<template>
  <header-section title="Panel de configuración" :tabs="tabs">
    <router-view />
  </header-section>
</template>
    
<script>
import BaseSection from "@/components/global/layout/BaseSection.vue";

// const CampusWithKnExplorer = [1,2,4,120,121,173,186];

export default {
  name: "settings-tabs",
  extends: BaseSection,
  data: () => ({
    tabs: [
      {
        title: "General",
        url: "/configuration/panel",
      },
      {
        title: "Kn·chat",
        url: "/configuration/panel/Kn-Chat",
      },
      {
        title: "Kn·Explorer",
        url: "/configuration/panel/Kn-Explorer",
      },
    ],
  }),
  async mounted() {
    // const campus = await this.$depAPI.util
    //   .getCampusData(this.$store.state.User.campus)
    //   .then((res) => res)
    //   .catch((err) => err);

    // if (campus && CampusWithKnExplorer.includes(campus.idCampusInt)) {
    //   this.tabs.push({
    //     title: "Kn·Explorer",
    //     url: "/configuration/panel/Kn-Explorer",
    //   });
    // }
  },
};
</script>
